module.exports = __webpack_public_path__ + "img/avito.35a18502.png";